<!-- Top section -->
<nav class="w-full rounded-xl">
    <ul class="flex mobile:flex-wrap items-center gap-8 px-6 pt-4">
        <li *ngFor="let section of sections; let i = index" (mouseenter)="onHoverSection(i)"
            class="cursor-pointer pb-2 relative select-none">

            <!-- If section has no items and has a link -->
            <a *ngIf="(!section.items || !section.items.length) && section.link" [routerLink]="section.link"
                class="transition"
                [ngClass]="[activeSectionIndex === i ? 'font-bold' : 'font-medium', isItemActive(section.activeSectionId ?? -1) ? 'text-primary' : ' text-neutral-1500']">
                {{ section.titleKey | transloco }}
            </a>

            <!-- Otherwise -->
            <span *ngIf="section.items?.length || !section.link" class="text-neutral-1500 transition"
                [ngClass]="[activeSectionIndex === i ? 'font-bold' : 'font-medium']">
                {{ section.titleKey | transloco }}
            </span>

            <span class="absolute left-0 -bottom-px h-0.5 rounded-full transition-all"
                [ngClass]="[activeSectionIndex === i ? 'w-full bg-neutral-1500' : 'w-0']">
            </span>
        </li>
    </ul>

    <!-- Sub sections -->
    <div class="px-6 pb-4 mt-2" *ngIf="sections[activeSectionIndex]?.items?.length">
        <ul class="flex flex-wrap items-center gap-x-8 gap-y-3">
            <li *ngFor="let item of sections[activeSectionIndex]?.items">
                <a [routerLink]="item.link" class="hover:font-bold" [ngClass]="['inline-flex items-center gap-2 text-sm transition',
         isItemActive(item.activeSectionId) ? 'text-primary font-bold' : ' font-medium text-neutral-1200']">
                    {{ item.translocoKey | transloco }}
                </a>
            </li>
        </ul>
    </div>
</nav>